// --- START OF FILE ClientsStyle.js ---

import styled from "styled-components";

// Estilos Reutilizáveis (Nosso "Design System")
export const PageContainer = styled.div`
    width: 100%;
    min-height: 100vh;
    padding: 40px;
    box-sizing: border-box;
    background-image: url('/textura.jpg');
    background-size: cover;
    background-attachment: fixed;
`;

export const ContentBox = styled.div`
    background: rgba(30, 30, 30, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 8px;
    padding: 30px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    h2 {
        margin: 0;
        color: #E6AA3A;
        font-size: 28px;
    }
`;

export const ActionButton = styled.button`
    background: #E6AA3A;
    color: #111;
    border: none;
    border-radius: 6px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;

    &:hover {
        background: #FFC300;
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(230, 170, 58, 0.4);
    }
`;

// Estilos Específicos da Página
export const StatsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-bottom: 40px;
`;

export const StatCard = styled.div`
    background: rgba(40, 40, 40, 0.8);
    border-radius: 8px;
    padding: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    
    h4 {
        margin: 0 0 10px 0;
        color: #fff;
        font-size: 14px;
        text-transform: uppercase;
        font-weight: 500;
        opacity: 0.8;
    }

    span {
        color: #E6AA3A;
        font-size: 32px;
        font-weight: 700;
    }
`;

export const FilterArea = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
    flex-wrap: wrap;
`;

export const SearchBar = styled.div`
    display: flex;
    flex-grow: 1;
    
    input {
        width: 100%;
        height: 45px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0,0,0,0.3);
        padding: 0 20px;
        color: #fff;
        border-radius: 6px 0 0 6px;
        font-size: 16px;

        &::placeholder { color: rgba(255,255,255,0.5); }
        &:focus {
            outline: none;
            border-color: #E6AA3A;
        }
    }
    
    button {
        width: 60px;
        height: 45px;
        border: none;
        background: #E6AA3A;
        color: #111;
        cursor: pointer;
        border-radius: 0 6px 6px 0;
        font-size: 18px;
        transition: background 0.3s;
        
        &:hover { background: #FFC300; }
    }
`;

export const FilterGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    color: #fff;

    select {
        height: 45px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0,0,0,0.3);
        padding: 0 15px;
        color: #fff;
        border-radius: 6px;
    }
`;

export const TableContainer = styled.div`
    width: 100%;
    overflow-x: auto;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    
    th, td {
        padding: 15px;
        text-align: left;
        white-space: nowrap;
    }

    thead tr {
        background-color: rgba(0,0,0,0.2);
        border-bottom: 2px solid #E6AA3A;
        th {
            color: #fff;
            font-weight: 600;
        }
    }
    
    tbody tr {
        color: rgba(255,255,255,0.9);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        transition: background-color 0.3s;
        cursor: pointer;
        
        &:hover {
            background-color: rgba(230, 170, 58, 0.1);
        }

        td:last-child {
            font-weight: 600;
            color: #E6AA3A;
        }
    }
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    gap: 15px;
    color: #fff;
`;

export const PaginationButton = styled.button`
    background: rgba(255,255,255,0.1);
    color: #fff;
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 6px;
    padding: 8px 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover:not(:disabled) {
        background: #E6AA3A;
        color: #111;
        border-color: #E6AA3A;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;